import { openDB } from 'idb'

let db = null

async function initDB(uuid) {
  if (uuid == null) return null
  db = await openDB(`oe_${uuid}`, 8, {
    upgrade(db, oldVersion, newVersion, transaction, event) {
      console.log('UPGRADE', { oldVersion, newVersion, transaction, event })
      // Create a store of objects
      let ordersStore
      if (!db.objectStoreNames.contains("orders")) {
        ordersStore = db.createObjectStore('orders', {
          keyPath: 'uuid',
          autoIncrement: false
        })
      } else {
        ordersStore = transaction.objectStore('orders');
      }
      if (!ordersStore.indexNames.contains("offline")) {
        ordersStore.createIndex("offline", "offline")
      }
      if (!ordersStore.indexNames.contains("insertDeviceUUID")) {
        ordersStore.createIndex("insertDeviceUUID", "insertDeviceUUID")
      }
      if (!ordersStore.indexNames.contains("orderState")) {
        ordersStore.createIndex("orderState", "orderState")
      }
      let paymentsStore
      if (!db.objectStoreNames.contains("externalPayments")) {
        paymentsStore = db.createObjectStore('externalPayments', {
          keyPath: 'uuid',
          autoIncrement: false
        })
      } else {
        paymentsStore = transaction.objectStore('externalPayments');
      }
      if (!paymentsStore.indexNames.contains("syncneeded")) {
        paymentsStore.createIndex("syncneeded", "syncneeded")
      }
      let shiftsStore
      if (!db.objectStoreNames.contains("shifts")) {
        shiftsStore = db.createObjectStore('shifts', {
          keyPath: 'uuid',
          autoIncrement: false
        })
      } else {
        shiftsStore = transaction.objectStore('shifts');
      }
      if (!shiftsStore.indexNames.contains("syncneeded")) {
        shiftsStore.createIndex("syncneeded", "syncneeded")
      }
      if (!shiftsStore.indexNames.contains("shiftStart")) {
        shiftsStore.createIndex("shiftStart", "shiftStart")
      }
      if (!shiftsStore.indexNames.contains("shiftEnd")) {
        shiftsStore.createIndex("shiftEnd", "shiftEnd")
      }
      // Transactions
      let transactionsStore
      if (!db.objectStoreNames.contains("transactions")) {
        transactionsStore = db.createObjectStore('transactions', {
          keyPath: 'uuid',
          autoIncrement: false
        })
      } else {
        transactionsStore = transaction.objectStore('transactions');
      }
      if (!transactionsStore.indexNames.contains("syncneeded")) {
        transactionsStore.createIndex("syncneeded", "syncneeded")
      }
      if (!transactionsStore.indexNames.contains("shiftUUID")) {
        transactionsStore.createIndex("shiftUUID", "shiftUUID")
      }
      if (!transactionsStore.indexNames.contains("documentUUID")) {
        transactionsStore.createIndex("documentUUID", "documentUUID")
      }
      // Documents
      let documentsStore
      if (!db.objectStoreNames.contains("documents")) {
        documentsStore = db.createObjectStore('documents', {
          keyPath: 'uuid',
          autoIncrement: false
        })
      } else {
        documentsStore = transaction.objectStore('documents');
      }
      if (!documentsStore.indexNames.contains("syncneeded")) {
        documentsStore.createIndex("syncneeded", "syncneeded")
      }
      if (!documentsStore.indexNames.contains("shiftUUID")) {
        documentsStore.createIndex("shiftUUID", "shiftUUID")
      }
      if (!documentsStore.indexNames.contains("refDocumentUUID")) {
        documentsStore.createIndex("refDocumentUUID", "refDocumentUUID")
      }
      // Items
      let itemsStore
      if (!db.objectStoreNames.contains("items")) {
        itemsStore = db.createObjectStore('items', {
          keyPath: 'uuid',
          autoIncrement: false
        })
      } else {
        itemsStore = transaction.objectStore('items');
      }
      if (!itemsStore.indexNames.contains("syncneeded")) {
        itemsStore.createIndex("syncneeded", "syncneeded")
      }
      if (!itemsStore.indexNames.contains("shiftUUID")) {
        itemsStore.createIndex("shiftUUID", "shiftUUID")
      }
      if (!itemsStore.indexNames.contains("documentUUID")) {
        itemsStore.createIndex("documentUUID", "documentUUID")
      }
      // Datas
      let datasStore
      if (!db.objectStoreNames.contains("document_data")) {
        datasStore = db.createObjectStore('document_data', {
          keyPath: 'uuid',
          autoIncrement: false
        })
      } else {
        datasStore = transaction.objectStore('document_data');
      }
      if (!datasStore.indexNames.contains("syncneeded")) {
        datasStore.createIndex("syncneeded", "syncneeded")
      }
      if (!datasStore.indexNames.contains("shiftUUID")) {
        datasStore.createIndex("shiftUUID", "shiftUUID")
      }
      if (!datasStore.indexNames.contains("documentUUID")) {
        datasStore.createIndex("documentUUID", "documentUUID")
      }
    },
    blocked(currentVersion, blockedVersion, event) {
      console.log('BLOCKED', { currentVersion, blockedVersion, event })
      // …
    },
    blocking(currentVersion, blockedVersion, event) {
      console.log('BLOCKING', { currentVersion, blockedVersion, event })
      // …
    },
    terminated() {
      console.log('TERMINATED')
      // …
    }
  })
  return db
}

async function storeOrder(order) {
  if (+order?.orderState === 0) return true
  let orderObj = JSON.parse(JSON.stringify(order))
  if (db == null) return false
  if (orderObj.offline == null) orderObj.offline = 0
  try {
    if (+order?.orderState < 90 || orderObj.offline) {
      await db.put('orders', orderObj)
    } else {
      await db.delete('orders', orderObj.uuid)
    }
    return true
  } catch (e) {
    console.log('put error', e)
    return false
  }
}

async function getDeviceOrdersAndUnsynced(uuid) {
  try {
    const index = db.transaction('orders').store.index('insertDeviceUUID')
    const keyRangeValue = IDBKeyRange.bound(uuid, uuid, false, false)
    let cursors = await index.getAll(keyRangeValue)
    const indexOffline = db.transaction('orders').store.index('offline')
    const keyRangeValueOffline = IDBKeyRange.bound(1, 1, false, false)
    let cursors2 = await indexOffline.getAll(keyRangeValueOffline)
    let all = [...cursors, ...cursors2]
    //console.log('getDeviceOrdersAndUnsynced', all)
    return all
  } catch (e) {
    return []
  }
}

async function getUnsyncedExternalPayments() {
  try {
    const index = db.transaction('externalPayments').store.index('syncneeded')
    const keyRangeValue = IDBKeyRange.bound(1, 1, false, false)
    let cursors = await index.getAll(keyRangeValue)
    return cursors
  } catch (e) {
    return []
  }
}

async function storeExternalPayment(payment) {
  let paymentObj = JSON.parse(JSON.stringify(payment))
  if (db == null) return null
  if (paymentObj.syncneeded == null) paymentObj.syncneeded = 0
  try {
    if (paymentObj.syncneeded) {
      await db.put('externalPayments', paymentObj)
    } else {
      await db.delete('externalPayments', paymentObj.uuid)
    }
  } catch (e) {
    console.log('put error payment', e)
  }
}

export {
  db,
  initDB,
  storeOrder,
  getDeviceOrdersAndUnsynced,
  storeExternalPayment,
  getUnsyncedExternalPayments
}
